import { Check } from "lucide-react";
const expertisePanels = [{
  id: "01",
  title: "Cinematic Narrative",
  items: ["High-End Brand Stories", "4K Digital Cinematography", "Artistic Visual Direction"]
}, {
  id: "02",
  title: "Digital Presence",
  items: ["Social Media Campaigns", "Website Hero Content", "Dynamic Stream Overlays"]
}, {
  id: "03",
  title: "Post-Production",
  items: ["Precision Color Grading", "Sound Design & Scoring", "Motion Graphic Design"]
}];
export default function OurExpertise() {
  return <section data-section-id="245321" id="creative-mediums" className="bg-background text-foreground py-24 overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-6 h-auto lg:h-[600px]">
          {expertisePanels.map((panel, i) => <div key={panel.id} data-index={i} className="group relative flex-1 flex flex-col justify-end p-8 lg:p-12 bg-secondary/20 hover:bg-secondary transition-all duration-700 ease-in-out-expo hover:flex-[1.15] border border-border rounded-none overflow-hidden">
              {}
              <span className="absolute -top-12 -right-8 text-[15rem] lg:text-[20rem] font-default font-bold text-foreground/5 leading-none select-none transition-transform duration-700 group-hover:scale-105 group-hover:text-primary/10">
                {panel.id}
              </span>

              {}
              <div className="relative z-10">
                <h3 className="font-default text-3xl lg:text-4xl font-bold mb-6 text-foreground tracking-tighter uppercase">
                  {panel.title}
                </h3>
                <ul className="space-y-4">
                  {panel.items.map((item, j) => <li key={j} data-index={j} className="flex items-start gap-3 text-muted-foreground group-hover:text-foreground transition-colors duration-500">
                      <Check className="w-5 h-5 mt-0.5 shrink-0 text-primary" />
                      <span className="text-lg font-mono leading-relaxed">{item}</span>
                    </li>)}
                </ul>
                
                <div className="mt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <button className="bg-primary text-primary-foreground px-6 py-3 font-mono text-sm uppercase tracking-widest">
                    View Projects
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}